
import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import Servicios from "../components/Servicios";




function ServiciosPage() {
  return (
    <>
    
      <section className="servicios-page">
        <HeroPages name="Seguros" /> 
        
        <Servicios />
       
        <div className="book-banner">
          <div className="book-banner__overlay"></div>
          <div className="container">
            <div className="text-content">
              <h2>Book a car by getting in touch with us</h2>
              <span>
                <i className="fa-solid fa-phone"></i>
                <h3>(123) 456-7869</h3>
              </span>
            </div>
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
}

export default ServiciosPage;
